// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Switch_tabs__DfvIn {
  width: 100%;
  max-width: 370px;
  margin: 60px auto 0 auto;
}
.Switch_darkmode__H\\+iQS {
  background-color: #1a1919;
}
.Switch_tablist__QhLro {
  display: flex;
  justify-content: space-around;
  width: 90%;
  /* padding:3px ; */
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px auto;
  background-color: #f3f2f0;
  border: none;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 300;
}
/* .footerElemnts{
    margin-top: 20px;
} */
/* Media Quries */
/* @media (max-width:1024px){
    .tablist{
        padding:3px ;
        padding-top:10px;
    }  
}
@media (max-width:768px){
    .tablist{
        padding:3px ;
    }  
} */
@media (max-width: 425px) {
  .Switch_tabs__DfvIn {
    width: 100%;
    margin-top: 0px;
    padding-top: 60px;
  }
  /* .tablist{
        padding:3px ;
    }    */
}
.Switch_informationIcon__-KLIC {
  margin-top: -15px;
  margin-left: 5px;
  padding: 0;
  outline: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/LandingPage/Switch.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;;GAEG;AACH,iBAAiB;AACjB;;;;;;;;;;GAUG;AACH;EACE;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;;UAEQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":[".tabs {\r\n  width: 100%;\r\n  max-width: 370px;\r\n  margin: 60px auto 0 auto;\r\n}\r\n.darkmode {\r\n  background-color: #1a1919;\r\n}\r\n.tablist {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 90%;\r\n  /* padding:3px ; */\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 auto 20px auto;\r\n  background-color: #f3f2f0;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 1rem;\r\n  font-weight: 300;\r\n}\r\n/* .footerElemnts{\r\n    margin-top: 20px;\r\n} */\r\n/* Media Quries */\r\n/* @media (max-width:1024px){\r\n    .tablist{\r\n        padding:3px ;\r\n        padding-top:10px;\r\n    }  \r\n}\r\n@media (max-width:768px){\r\n    .tablist{\r\n        padding:3px ;\r\n    }  \r\n} */\r\n@media (max-width: 425px) {\r\n  .tabs {\r\n    width: 100%;\r\n    margin-top: 0px;\r\n    padding-top: 60px;\r\n  }\r\n  /* .tablist{\r\n        padding:3px ;\r\n    }    */\r\n}\r\n.informationIcon {\r\n  margin-top: -15px;\r\n  margin-left: 5px;\r\n  padding: 0;\r\n  outline: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `Switch_tabs__DfvIn`,
	"darkmode": `Switch_darkmode__H+iQS`,
	"tablist": `Switch_tablist__QhLro`,
	"informationIcon": `Switch_informationIcon__-KLIC`
};
export default ___CSS_LOADER_EXPORT___;
